import type { PaginatedResult } from './common';

export enum JobStatus {
  PENDING = 'pending',
  RUNNING = 'running',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
  PARTIAL = 'partial',
  CANCELLED = 'cancelled',
}

export enum JobTrigger {
  ONBOARDING = 'onboarding',
  SCHEDULED = 'scheduled',
  MANUAL = 'manual',
  RETRY = 'retry',
  WEBHOOK = 'webhook',
  SYSTEM = 'system',
}

export enum JobInitiatorKind {
  USER = 'user',
  SYSTEM = 'system',
  SCHEDULE = 'schedule',
  WEBHOOK = 'webhook',
  API = 'api',
}

export interface JobError {
  code: string;
  message: string;
  details?: Record<string, unknown>;
}

export interface JobProgress {
  total: number | null;
  succeeded: number;
  failed: number;
  cancelled: number;
}

export interface Job {
  _id: string;
  accountId: string;
  type: string;
  origin: string;
  status: JobStatus;
  trigger: JobTrigger;
  initiatedBy: { kind: JobInitiatorKind; id?: string; label?: string };
  params: Record<string, unknown>;
  progress: JobProgress;
  createdTaskCount: number;
  metadata: Record<string, unknown>;
  error?: JobError;
  createdAt: string;
  updatedAt: string;
  startedAt?: string;
  finishedAt?: string;
}

export type ListJobsResponse = PaginatedResult<Job>;
